export default __webpack_public_path__ + "static/benefitImg-ec7b06c7ad10fc35c08253ad97a1394d.png";